import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { FaIconModule } from '../shared/modules/fa-icon/fa-icon.module';
import { SearchbarComponent } from './navbar/searchbar/searchbar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { JsonLdComponent } from './json-ld/json-ld.component';
// comment for commit


@NgModule({
  declarations: [
    NavbarComponent,
    FooterComponent,
    SearchbarComponent,
    JsonLdComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FaIconModule,
    FormsModule,
    NgbDropdownModule,
    ReactiveFormsModule
  ],
  exports: [
    NavbarComponent,
    FooterComponent,
    JsonLdComponent
  ]
})
export class ComponentsModule { }
